import { markets } from 'constants/markets';
import MarketHelper from 'helpers/MarketHelper';
import { GetServerSidePropsContext } from 'next';
import { getReferrerMarket } from 'server/getReferrerMarket';

export async function parseContextLocale(
    context: GetServerSidePropsContext,
) {
    // Next's resolved locale is the reliable market signal: it is set from the URL's
    // locale segment for both hard loads AND client-side /_next/data soft-nav requests.
    // URL-based detection (getReferrerMarket) fails for data requests because their
    // path starts with /_next/data/... so the leading /sv (sefi) prefix is missed,
    // which made soft-navigation on the sefi market fall back to Finnish.
    if (context.locale) {
        return markets[MarketHelper.localeToMarket(context.locale)];
    }

    const host = context.req.headers['x-forwarded-host']
        ?? context.req.headers.referer
        ?? context.req.headers.host;

    const pathname = context.req.url ?? '';

    const market = MarketHelper.formatMarket(getReferrerMarket(host + pathname));

    return markets[market];
}
